import React, { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import ModifyReceiptTable from "../components/ModifyReceiptTable";
import loadercrs from "../assets/images/loadercrs.gif";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { TextField, MenuItem } from "@mui/material";
import HighestSaleDeedTable from "../components/HighestSaleDeedTable";
import { useLocation } from "react-router-dom";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const IndexForm = () => {
  const location = useLocation();
  const Index = location.state.Index
  const { userDetails } = useSelector((state) => state.auth);
  const today = dayjs(); // Use Dayjs for date handling

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [allCashReceiptData, setAllCashReceiptData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hname, setHname] = useState(""); 
  const [hindiVarmala, setHindiVarmala] = useState("")

console.log(hindiVarmala)

  const fetchHindiVarmala = async () => {
debugger
try {
  const response = await axios.get(
    `${API_BASE_URL}/Master/Virtual_GetHindiMaster`
  )
  setHindiVarmala(response.data.data)
}  catch (error) {
  console.error("Error fetching hindi data:", error)
}

  }

  const handleOkButtonClick = () => {

  const reportUrl = `${REPORT_BASE_URL}/Report/Index.aspx?dcode=${userDetails.dcode}&srocode=${userDetails.srocode}&fdate=${fromDate.format("YYYY-MM-DD")}&tdate=${toDate.format("YYYY-MM-DD")}&letter=${hname}&index=${Index.replace(/\s/g,"")}`;
  
    window.open(reportUrl, "_blank"); 
    setFromDate(today);
    setToDate(today);
    setHname("");
  }

  useEffect(() => {
   
    fetchHindiVarmala();
  }, []);



  return (
    <>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <img src={loadercrs} alt="Loading..." className="w-48 h-48" />
        </div>
      )}

      <div className={`flex h-screen ${loading ? "pointer-events-none blur-sm" : ""}`}>
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>
          <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
            <div className="flex-1 p-4 overflow-y-auto">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 mx-4">
                {Index}
              </h1>
              <div className="max-w-full mx-auto p-1 rounded-md">
                <div className="flex flex-col md:flex-row w-3/4 items-end gap-2">
                  {/* From Date */}
                  <div className="flex-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                        format="YYYY-MM-DD"
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </div>

                  {/* To Date */}
                  <div className="flex-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(newValue) => setToDate(newValue)}
                        format="YYYY-MM-DD"
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </div>

                  {/* On Behalf of Dropdown */}
                  <div className="flex-1">
  <TextField
    select
    label="Select Letter"
    fullWidth
    variant="outlined"
    size="small"
    value={hname}
    onChange={(e) => setHname(e.target.value)}
    required
  >
    <MenuItem disabled value="">Select</MenuItem>
   
    {Array.isArray(hindiVarmala) && hindiVarmala.length > 0 ? (
  hindiVarmala.map((hindiVarmalas) => (
    <MenuItem key={hindiVarmalas.hname} value={hindiVarmalas.hname}>
      {hindiVarmalas.hname}
    </MenuItem>
  ))
) : (
  <MenuItem disabled>No options available</MenuItem>
)}
 
  </TextField>
</div>



                  {/* OK Button */}
                  <div className="flex">
                    <button
                      className="bg-blue-500 text-white text-sm px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none md:ml-2 mt-5 md:mt-1"
                      onClick={handleOkButtonClick}
                    >
                      OK
                    </button>
                  </div>
                </div>

             
              </div>
            </div>

            <div className="hidden md:block w-full md:w-64 h-full p-4">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndexForm;
